import React from 'react'
import BaseIcon from 'react-icon-base'

const JP = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>JP</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <filter id="b" width="104.8%" height="106.7%" x="-2.4%" y="-3.3%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius="1" result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121659873 0" />
      </filter>
      <rect id="d" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="c" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <use fill="#000" filter="url(#b)" xlinkHref="#a" />
      <circle cx="10.5" cy="7.5" r="3.5" fill="#BD0536" mask="url(#c)" />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#d" />
    </g>
  </BaseIcon>
)

export default JP
